import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import routerLoader from '../../i18n/router';
import CustomPaginationTable from './CustomPaginationTable';
import IconFilledBag from '../../Icons/IconFilledBag';
import IconSaving from '../../Icons/IconSaving';
import IconCar from '../../Icons/IconCar';
import { AppContextType } from '../../store/AppContext';
import NoData from '../../components/NoData';
import { StylesSwapHelper } from '../../utils/StylesSwapHelper';
import { StorageHelper } from '../../utils/StorageHelper';
import Title from '../../components/Title';
import { AuthContextType, SaldoData } from '../../types/Types';
import BotonVolverFlotante from '../../components/BotonVolverFlotante';
import DownloadAppPopup from '../../components/DownloadAppPopup';

interface Props {
  dataUser: AuthContextType;
  ahorrado: number;
  view: boolean;
  dataApp: AppContextType;
  backError: boolean;
  saldoData: SaldoData[];
}

const SaldoEroski: FC<Props> = (props) => {
  const { t } = useTranslation();
  const { dataUser, ahorrado, view, dataApp, backError, saldoData } = props;

  return (
    <>
      <BotonVolverFlotante />
      {(() => {
        const isApp = dataUser.user.isApp === 'true';
        const isEcommerceBot = StorageHelper.isEcommerceBot();
        StylesSwapHelper.swapStyleIfApp(isApp || isEcommerceBot);
        return (
          <>
            <section className="o-section--medium o-section--no-padding-top  section--background">
              <div className="container">
                <div className="cabecera-seccion">
                  <Title
                    titleName={t('saldo.title')}
                    titleValue={ahorrado}
                    numText={t('saldo.savedMoney')}
                    page="saldo"
                    isLoad={view}
                  />

                  <div className="links-cabecera">
                    <div className="icon-link-block u-margin-bottom-small u-display-none-only-mobile-tablet">
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a
                        href={routerLoader.LoadRouterByPath(
                          'ahorros',
                          dataApp.lang,
                        )}
                        className="icon-link u-align-items-baseline"
                      >
                        <div className="icon icon-medium icon--grey ">
                          <IconSaving />
                        </div>
                        <span className="u-font-small u-text-brand u-text-decoration-underline">
                          {t('saldo.mySavings')}
                        </span>
                      </a>
                    </div>
                    {!dataUser.user.isGibraltar && (
                      <div className="icon-link-block u-margin-bottom-small u-display-none-only-mobile-tablet">
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <a
                          href={routerLoader.LoadRouterByPath(
                            'compras-y-tickets',
                            dataApp.lang,
                          )}
                          className="icon-link u-align-items-baseline"
                        >
                          <div className="icon icon-medium icon--grey ">
                            <IconFilledBag />
                          </div>
                          <span className="u-font-small u-text-brand u-text-decoration-underline">
                            {t('saldo.myShopping')}
                          </span>
                        </a>
                      </div>
                    )}
                    <div className="icon-link-block u-margin-bottom-small">
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      {dataUser.user.isApp === 'false' ? (
                        <a
                          href={`${
                            process.env.REACT_APP_API
                          }/clienteLogado/getTK?fromUrl=${
                            process.env.REACT_APP_SERVER_SUPER
                          }${t('link.super')}&fromApp=${t('web_ecommerce')}`}
                          rel="noopener noreferrer"
                          className="icon-link u-align-items-baseline"
                          title="Super online, enlace"
                        >
                          <div className="icon icon-medium icon--grey ">
                            <IconCar />
                          </div>
                          <span className="u-font-small u-text-brand u-text-decoration-underline">
                            {t('saldo.superOnline')}
                          </span>
                        </a>
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="o-section--large saldoPage">
              <div className="container-inner__small">
                {(() => {
                  if (!backError) {
                    return <CustomPaginationTable data={saldoData} />;
                  }

                  return (
                    <NoData>
                      <div className="mensaje">
                        <p>{t('saldo.noRecords')}</p>
                      </div>
                    </NoData>
                  );
                })()}
              </div>
            </section>
            <DownloadAppPopup page="saldo" />
          </>
        );
      })()}
    </>
  );
};

export default SaldoEroski;
